import { render, staticRenderFns } from "./AfValidationProvider.vue?vue&type=template&id=f772a5f8"
import script from "./AfValidationProvider.vue?vue&type=script&lang=js"
export * from "./AfValidationProvider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports